module.exports = __webpack_public_path__ + "img/carrot.f19edef7.svg";